export default "__VITE_ASSET__rKED406___"